import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { RequiredProductNames } from '../../../constants/CourseConstants';
import { BaseContentControlWrapper } from '../../../components/ContentControlWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PRODUCT_TO_ICON_MAP = {
  [RequiredProductNames.crm]: 'crm',
  [RequiredProductNames.marketing]: 'marketing-free',
  [RequiredProductNames.sales]: 'sales-free'
};

// @bend-expect trellis-tokenized
const ContentWrapper = styled.div.withConfig({
  displayName: "PracticalExerciseRequiredAccess__ContentWrapper"
})(["padding:10%;width:100%;height:100%;"]);
const PracticalExerciseRequiredAccess = ({
  advanceToNextContent,
  product
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ContentWrapper, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        blockSize: "100%",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h1",
          marginBlockEnd: "400",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.practicalExercise.requiredAccess.${product}.header`
          })
        }), /*#__PURE__*/_jsx(Illustration, {
          name: PRODUCT_TO_ICON_MAP[product]
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockStart: "500",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.practicalExercise.requiredAccess.${product}.description`
          })
        })]
      })
    }), /*#__PURE__*/_jsx(BaseContentControlWrapper, {
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "skip-nonstarted-practical-exercise",
        marginInlineEnd: !isMobile ? '300' : undefined,
        onClick: advanceToNextContent,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.skip"
        })
      })
    })]
  });
};
export default PracticalExerciseRequiredAccess;